import { render, staticRenderFns } from "./repayment-manage.vue?vue&type=template&id=4b72a1b6"
import script from "./repayment-manage.vue?vue&type=script&lang=ts"
export * from "./repayment-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports